import { MutationTree } from 'vuex'
import { AuthState } from '../types'
import setAuth from './setAuth'

const mutations: MutationTree<AuthState> = {
  setAuth,
}

export default mutations
